const getDefaultDebitFrequency = ({ required, defaultValue, options }) => {
  if (!required) return null;

  return defaultValue || options?.find(({ AUTORISE }) => AUTORISE === 'true')?.CODE || null;
};

export default getDefaultDebitFrequency;
